import { Component, Inject, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwEventService, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwSectionBaseComponent, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CourseLessonEntity, StudentCourseEntity, StudentCourseProgressQueryEntity } from '../../../../../meta-data/app-meta-data.service';
import { DateTimeUtilService } from '../../../../shared/util/date-time-util.service';
import { ACSSubmissionUtilService } from '../../../../students/services/acs-submission-util.service';
import { DwPubSubEventTopics } from '../../../../z-devware/pubsub/models/dw-pub-sub-event-topics.model';
import { CourseNavigationService } from '../../../services/course-navigation.service';
import { CourseRepositoryService } from '../../../services/course-repository.service';


@DwComponent({
  key: 'courseStudentProgressFormCard',
  name: 'Course Student Progress Card - Form',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.StudentCourse,
  isGlobal: false,
})
@Component({
  selector: 'app-course-student-progress-form-card',
  template: `
    <div class="progress-list course-progress-list">
      <app-course-student-progress-card [data]="studentCourseProgress"></app-course-student-progress-card>
    </div>
  `
})
export class CourseStudentProgressFormCardComponent  extends DwSectionBaseComponent {
  formApi: DwMetaDataFormApi;
  studentCourseProgress: StudentCourseProgressQueryEntity;
  studentCourse: StudentCourseEntity;
  private progressLoadRequestId = 0;

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private courseRepositoryService: CourseRepositoryService,
    private dwEventService: DwEventService,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }
  ngOnInit(): void {
    this.setupSection();
    this.setupStatusRefreshEvents();
  }

  setupSection() {
    this.studentCourse = this.formApi.getFormData<StudentCourseEntity>();
    const studentCourseId = this.studentCourse?.StudentCourseId;

    if (!studentCourseId) {
      return;
    }

    const loadRequestId = ++this.progressLoadRequestId;

    this.courseRepositoryService.getStudentCourseProgressQuery(studentCourseId)
      .subscribe(studentCourseProgress => {
        if (loadRequestId === this.progressLoadRequestId) {
          this.studentCourseProgress = studentCourseProgress;
        }
      });
  }

  private setupStatusRefreshEvents(): void {
    const statusItemNames = [
      AppMetaDataItemNames.StudentCourse,
      AppMetaDataItemNames.AcsWrittenResult
    ];

    statusItemNames.forEach(itemName => {
      this.subscriptions.push(
        this.dwEventService
          .getEventData(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(itemName))
          .subscribe(() => this.setupSection())
      );
    });

    this.subscriptions.push(
      this.dwEventService
        .getEventData(DwPubSubEventTopics.messageReceived(ACSSubmissionUtilService.ACS_WRITTEN_RESULT_TOPIC))
        .subscribe(() => this.setupSection())
    );
  }

}
